import {
  RowDataReducerState,
  RowDataReducerAction,
} from "../../../../../types";
import { isNewRecord } from "../../../helpers";

export const getInventoryBuildingsPriority = ({
  propertyKey,
  rowDataReducerState,
  dispatch,
}: {
  propertyKey: string;
  rowDataReducerState: RowDataReducerState;
  dispatch: React.Dispatch<RowDataReducerAction>;
}): void => {
  const { rowData } = rowDataReducerState;

  if (isNewRecord(rowData)) {
    const existingPriorities = rowDataReducerState.rowDataList.map(
      (row) => row[propertyKey] as number,
    );

    const nextPriority =
      existingPriorities.length > 0 ? Math.max(...existingPriorities) + 1 : 1;

    dispatch({
      type: "UPDATE_FIELD",
      payload: {
        propertyKey,
        newFieldValue: nextPriority,
      },
    });

    // Need this to manage `Clear Changes` button state in New/Edit/Clone entries
    dispatch({
      type: "UPDATE_ROW_DATA_REDUCER_STATE",
      payload: {
        resetState: {
          newEntryRowData: {
            ...rowDataReducerState.resetState?.newEntryRowData,
            [propertyKey]: nextPriority,
          },
        },
      },
    });
  }
};
